import { autoinject, customElement } from "aurelia-framework";

@customElement("toast-placeholder")
@autoinject
export class ToastPlaceholder {
    // Empty class. We only need the custom element decorator and you can set the id to this element in the html.
}
